import { CgSpinner } from 'react-icons/cg';

type SpinnerProps = {
  className?: string;
};

export function Spinner({ className = '' }: SpinnerProps) {
  return (
    <CgSpinner className={`ml-2 animate-spin text-gray-700 ${className}`} />
  );
}
